<div *ngIf="rowData.frontBanner == true">
    <app-front-banner [contentData]="rowData.content"></app-front-banner>
</div>
<div *ngIf="!rowData.frontBanner" [class]="'itemRow ' + rowStyle">
    <h2 *ngIf="rowData.title">{{ rowData.title }}</h2>
    <div *ngIf="!rowData" class="full-row empty-row"></div>
    <div *ngIf="rowData && rowData.boxes.length == 1" class="row full-row">
        <div class="no-full-row-frame">
            <app-box-layout [boxData]="rowData.boxes[0]"></app-box-layout>
        </div>
    </div>
    <div *ngIf="rowData && rowData.boxes.length > 1" class="double-row-container">
        <div class="no-full-frame">
            <div class="row double-row">
                <div class="no-half-frame">
                    <app-box-layout [boxData]="rowData.boxes[0]" ></app-box-layout>
                </div>
            </div>
            <div class="row double-row">
                <div class="no-half-frame">
                    <app-box-layout [boxData]="rowData.boxes[1]"></app-box-layout>
                </div>
            </div>
        </div>
    </div>
</div>